import React from 'react';
import DelegationsTab from '../components/settings/DelegationsTab';

/**
 * Yönetim > Vekaletler — şubedeki TÜM vekaletler, başkası adına vekalet
 * açma dahil.
 *
 * Profil > "Vekaletlerim" ile AYNI bileşeni kullanıyor, farkı kapsam:
 * orası `mine` ile çağırıyor ve her rolde yalnızca kişinin kendi
 * kayıtlarını gösteriyor. Ayrılmasının sebebi, tek yüzey varken
 * yöneticinin kendi profilinde başkalarının vekaletlerini görmesiydi
 * (07.10.2026'da kullanıcı bildirdi).
 *
 * Rotada `permission` KULLANILMIYOR, yalnızca `roles={MANAGER_ROLES}`:
 * `delegations.view` izni öğretmende de var (izne çıkarken dersini
 * devredebilsin diye, bkz. backend/CLAUDE.md) ve hem `ProtectedRoute` hem
 * menüdeki `buildGroup` izni rolün yerine geçen bir KAÇIŞ KAPISI olarak
 * değerlendiriyor. İzin yazılsaydı bu sayfa bütün öğretmenlere açılırdı —
 * "Kullanıcılar" kaleminde aynı tuzağa düşülmüş ve `users.view` yerine
 * `users.edit` seçilerek çözülmüştü.
 */
const Delegations = () => (
  <div>
    <h2 className="text-2xl font-bold mb-6">Vekaletler</h2>
    <DelegationsTab />
  </div>
);

export default Delegations;
